document.addEventListener("DOMContentLoaded", () => {

    /* ==========================================================================
       1. LIVE SEARCH AUTOCOMPLETE SYSTEM (Shopify Predictive Search)
       ========================================================================== */
    const searchInput = document.getElementById("dc-search-input");
    const liveSearch = document.getElementById("dc-live-search");
    const searchWrapper = document.querySelector(".dc-search-wrapper");

    if (searchInput && liveSearch) {
        const loadDefaultSuggestions = () => {
            fetch(`/search/suggest.json?q=parts&resources[type]=product&resources[limit]=5`)
                .then(res => res.json())
                .then(data => {
                    const products = data.resources.results.products;
                    if (products && products.length > 0) {
                        let html = `<div style="padding: 6px 12px 10px; font-size: 11px; font-weight: 800; text-transform: uppercase; color: var(--slate-muted); letter-spacing: 1px; border-bottom: 1px solid var(--slate-border); margin-bottom: 8px;">Suggested Products</div>`;
                        products.forEach(product => {
                            const price = product.price_max ? '$' + parseFloat(product.price_max).toFixed(2) : '';
                            html += `
                                <a href="${product.url}" class="dc-live-item">
                                    <div class="dc-live-image">
                                        <img src="${product.image || '//www.discountcombineparts.com.au/cdn/shop/files/ChatGPT_Image_May_16_2026_at_11_33_35_AM.png?width=100'}" alt="${product.title}" />
                                    </div>
                                    <div class="dc-live-content">
                                        <span class="dc-live-title">${product.title}</span>
                                        <span>${price}</span>
                                    </div>
                                </a>
                            `;
                        });
                        liveSearch.innerHTML = html;
                    }
                })
                .catch(err => console.error("Error loading default suggestions:", err));
        };

        // Load default suggestions initially so they are ready
        loadDefaultSuggestions();

        const performSearch = (query) => {
            if (query.length < 2) {
                loadDefaultSuggestions();
                return;
            }

            fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag`)
                .then(res => res.json())
                .then(data => {
                    const products = data.resources.results.products;
                    if (products && products.length > 0) {
                        let html = "";
                        products.forEach(product => {
                            const price = product.price_max ? '$' + parseFloat(product.price_max).toFixed(2) : '';
                            html += `
                                <a href="${product.url}" class="dc-live-item">
                                    <div class="dc-live-image">
                                        <img src="${product.image || '//www.discountcombineparts.com.au/cdn/shop/files/ChatGPT_Image_May_16_2026_at_11_33_35_AM.png?width=100'}" alt="${product.title}" />
                                    </div>
                                    <div class="dc-live-content">
                                        <span class="dc-live-title">${product.title}</span>
                                        <span>${price}</span>
                                    </div>
                                </a>
                            `;
                        });
                        liveSearch.innerHTML = html;
                        liveSearch.style.display = "block";
                    } else {
                        liveSearch.innerHTML = `<div class="dc-live-search-no-results" style="padding: 12px; font-size: 14px; color: var(--slate-muted); text-align: center;">No products found for "${query}"</div>`;
                        liveSearch.style.display = "block";
                    }
                })
                .catch(err => {
                    console.error("Predictive search error:", err);
                });
        };

        let debounceTimeout;
        searchInput.addEventListener("input", (e) => {
            const query = e.target.value.trim();
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                performSearch(query);
            }, 300);
        });

        // Show search dropdown on focus
        searchInput.addEventListener("focus", () => {
            if (searchInput.value.trim() === "") {
                loadDefaultSuggestions();
            }
            liveSearch.style.display = "block";
        });

        // Hide search dropdown when clicking outside
        document.addEventListener("click", (event) => {
            if (searchWrapper && !searchWrapper.contains(event.target)) {
                liveSearch.style.display = "none";
            }
        });
    }

    /* ==========================================================================
       2. MOBILE MENU DRAWER
       ========================================================================== */
    const mobileToggle = document.getElementById("dc-mobile-toggle") ||
                         document.querySelector(".dc-mobile-toggle");
    const mobileMenu = document.getElementById("dc-mobile-menu");
    const mobileOverlay = document.getElementById("dc-mobile-overlay");
    const mobileCloseBtn = document.getElementById("dc-mobile-menu-close");

    if (mobileToggle && mobileMenu && mobileOverlay && mobileCloseBtn) {
        const openMobileMenu = () => {
            mobileMenu.classList.add("active");
            mobileOverlay.classList.add("active");
            mobileToggle.classList.add("active");
            mobileToggle.setAttribute("aria-expanded", "true");
            mobileToggle.setAttribute("aria-label", "Close mobile menu");
            document.body.style.overflow = "hidden";
        };

        const closeMobileMenu = () => {
            mobileMenu.classList.remove("active");
            mobileOverlay.classList.remove("active");
            mobileToggle.classList.remove("active");
            mobileToggle.setAttribute("aria-expanded", "false");
            mobileToggle.setAttribute("aria-label", "Open mobile menu");
            document.body.style.overflow = "";
        };

        mobileToggle.addEventListener("click", () => {
            const isOpen = mobileMenu.classList.contains("active");
            isOpen ? closeMobileMenu() : openMobileMenu();
        });
        mobileCloseBtn.addEventListener("click", closeMobileMenu);
        mobileOverlay.addEventListener("click", closeMobileMenu);

        // Mobile submenu accordion (max-height animation)
        const dropdownToggles = mobileMenu.querySelectorAll(".dc-mobile-dropdown-toggle");
        dropdownToggles.forEach(toggle => {
            toggle.addEventListener("click", () => {
                const parentItem = toggle.closest(".dc-mobile-nav-item");
                if (!parentItem) return;

                const isActive = parentItem.classList.contains("active");

                // Close all other open items
                dropdownToggles.forEach(otherToggle => {
                    const otherItem = otherToggle.closest(".dc-mobile-nav-item");
                    if (otherItem && otherItem !== parentItem) {
                        otherItem.classList.remove("active");
                        otherToggle.setAttribute("aria-expanded", "false");
                    }
                });

                // Toggle this item
                if (isActive) {
                    parentItem.classList.remove("active");
                    toggle.setAttribute("aria-expanded", "false");
                } else {
                    parentItem.classList.add("active");
                    toggle.setAttribute("aria-expanded", "true");
                }
            });
        });
    }

    /* ==========================================================================
       2b. STICKY HEADER — SCROLL-TRIGGERED COMPACT MODE
       ========================================================================== */
    const dcHeader = document.querySelector(".dc-header");
    if (dcHeader) {
        // Add padding to body to prevent content from hiding under fixed header
        const updateHeaderPadding = () => {
            document.body.style.paddingTop = dcHeader.offsetHeight + 'px';
        };
        updateHeaderPadding();
        window.addEventListener('resize', updateHeaderPadding);

        const SCROLL_THRESHOLD = 60;
        const handleHeaderScroll = () => {
            if (window.scrollY > SCROLL_THRESHOLD) {
                dcHeader.classList.add("dc-header--scrolled");
            } else {
                dcHeader.classList.remove("dc-header--scrolled");
            }
        };
        // Passive listener for performance
        window.addEventListener("scroll", handleHeaderScroll, { passive: true });
        // Apply on initial load in case page refreshes mid-scroll
        handleHeaderScroll();
    }

    /* ==========================================================================
       3. HERO SECTION inline READ MORE
       ========================================================================== */
    const heroReadMoreBtn = document.getElementById("dc-hero-readmore-btn");
    const heroMoreText = document.getElementById("dc-hero-more-text");

    if (heroReadMoreBtn && heroMoreText) {
        heroReadMoreBtn.addEventListener("click", () => {
            const isActive = heroMoreText.classList.toggle("active");

            if (isActive) {
                heroReadMoreBtn.textContent = "Read Less";
                heroReadMoreBtn.style.color = "var(--white)";
            } else {
                heroReadMoreBtn.textContent = "Read More";
                heroReadMoreBtn.style.color = "var(--accent)";
            }
        });
    }

    /* ==========================================================================
       4. SWIPER INSTANTIATION (PARTS SLIDER)
       ========================================================================== */
    const partsSwiper = new Swiper(".dcPartsSlider", {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 800,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        navigation: {
            nextEl: ".dc-slider-next",
            prevEl: ".dc-slider-prev",
        }
    });

    /* ==========================================================================
       5. PARTS TABS INTERACTION & SYNC
       ========================================================================== */
    const tabButtons = document.querySelectorAll(".dc-tab-btn");

    if (tabButtons.length > 0 && partsSwiper) {
        // Tab button click event
        tabButtons.forEach(button => {
            button.addEventListener("click", () => {
                const targetIndex = parseInt(button.getAttribute("data-index"), 10);

                // Set active class on clicked tab
                tabButtons.forEach(btn => btn.classList.remove("active"));
                button.classList.add("active");

                // Instruct Swiper to navigate to matching index
                partsSwiper.slideToLoop(targetIndex);
            });
        });

        // Sync tabs with Swiper auto sliding
        partsSwiper.on("slideChange", () => {
            const realIndex = partsSwiper.realIndex;

            tabButtons.forEach(button => {
                const buttonIndex = parseInt(button.getAttribute("data-index"), 10);
                if (buttonIndex === realIndex) {
                    button.classList.add("active");

                    // Smoothly scroll active tab into view within its local wrapper (no page jumps/redirects)
                    const wrapper = document.querySelector(".dc-parts-tabs-wrapper");
                    if (wrapper) {
                        const buttonLeft = button.offsetLeft;
                        const buttonWidth = button.offsetWidth;
                        const wrapperWidth = wrapper.offsetWidth;
                        const wrapperScrollLeft = wrapper.scrollLeft;

                        if (buttonLeft < wrapperScrollLeft || (buttonLeft + buttonWidth) > (wrapperScrollLeft + wrapperWidth)) {
                            wrapper.scrollTo({
                                left: buttonLeft - (wrapperWidth / 2) + (buttonWidth / 2),
                                behavior: "smooth"
                            });
                        }
                    }
                } else {
                    button.classList.remove("active");
                }
            });
        });
    }

    /* ==========================================================================
       6. BRAND ACCORDION SHIELD (details group limit)
       ========================================================================== */
    const brandCards = document.querySelectorAll(".dc-brand-card");

    brandCards.forEach(card => {
        const detailsElements = card.querySelectorAll(".dc-brand-details");

        detailsElements.forEach(details => {
            details.addEventListener("toggle", () => {
                if (details.open) {
                    // Close other details panels within same brand card
                    detailsElements.forEach(el => {
                        if (el !== details) {
                            el.removeAttribute("open");
                        }
                    });
                }
            });
        });
    });

    /* ==========================================================================
       7. WHY CHOOSE US ACCORDION SYSTEM (Dynamic height)
       ========================================================================== */
    /* ==========================================================================
       7. WHY CHOOSE US ACCORDION SYSTEM (Dynamic height & Image Sync)
       ========================================================================== */
    const initWhyChooseAccordionHeights = () => {
        const accordionItems = document.querySelectorAll(".dc-accordion-item");
        accordionItems.forEach(item => {
            const content = item.querySelector(".dc-accordion-content");
            if (item.classList.contains("active") && content) {
                content.style.maxHeight = content.scrollHeight + "px";
            } else if (content) {
                content.style.maxHeight = "0px";
            }
        });
    };
    initWhyChooseAccordionHeights();

    // Event delegation for why-choose accordion toggles
    document.addEventListener("click", (event) => {
        const header = event.target.closest(".dc-accordion-header");
        if (!header) return;

        const item = header.closest(".dc-accordion-item");
        if (!item) return;

        const accordion = item.closest(".dc-why-accordion");
        if (!accordion) return;

        const content = item.querySelector(".dc-accordion-content");
        if (!content) return;

        const accordionItems = accordion.querySelectorAll(".dc-accordion-item");
        const isActive = item.classList.contains("active");

        // Close all open items
        accordionItems.forEach(otherItem => {
            otherItem.classList.remove("active");
            const otherContent = otherItem.querySelector(".dc-accordion-content");
            if (otherContent) {
                otherContent.style.maxHeight = "0px";
            }
        });

        // Toggle active item
        if (!isActive) {
            item.classList.add("active");
            content.style.maxHeight = content.scrollHeight + "px";

            // Sync active visual image highlight
            const targetIndex = item.getAttribute("data-index");
            const grid = accordion.closest(".dc-why-grid");
            if (grid) {
                const imageItems = grid.querySelectorAll(".dc-why-image-item");
                imageItems.forEach(imgItem => {
                    if (imgItem.getAttribute("data-index") === targetIndex) {
                        imgItem.classList.add("active");
                    } else {
                        imgItem.classList.remove("active");
                    }
                });
            }
        }
    });

    // Re-initialize heights on Shopify Section events
    document.addEventListener("shopify:section:load", initWhyChooseAccordionHeights);
    document.addEventListener("shopify:section:select", initWhyChooseAccordionHeights);

    /* ==========================================================================
       8. SWIPER INSTANTIATION (TESTIMONIALS SLIDER)
       ========================================================================== */


    /* ==========================================================================
       9. FAQ ACCORDION TABS & TOGGLES
       ========================================================================== */
    const faqTabs = document.querySelectorAll(".dc-faq-tab");
    const faqContentItems = document.querySelectorAll(".dc-faq-content-item");

    // Handling FAQ category switches
    faqTabs.forEach(tab => {
        tab.addEventListener("click", () => {
            const targetTab = tab.getAttribute("data-tab");

            // Tab button highlights
            faqTabs.forEach(btn => btn.classList.remove("active"));
            tab.classList.add("active");

            // Swap out category lists
            faqContentItems.forEach(item => {
                if (item.getAttribute("id") === targetTab) {
                    item.classList.add("active");

                    // Reinitialize max-height on active category accordions
                    const activeCards = item.querySelectorAll(".dc-faq-card");
                    activeCards.forEach(card => {
                        const answer = card.querySelector(".dc-faq-answer");
                        if (card.classList.contains("active") && answer) {
                            answer.style.maxHeight = answer.scrollHeight + "px";
                        } else if (answer) {
                            answer.style.maxHeight = "0px";
                        }
                    });

                } else {
                    item.classList.remove("active");
                }
            });
        });
    });

    // Handling individual FAQ card accordions
    const faqCards = document.querySelectorAll(".dc-faq-card");

    faqCards.forEach(card => {
        const questionBlock = card.querySelector(".dc-faq-question");
        const answerBlock = card.querySelector(".dc-faq-answer");

        if (questionBlock && answerBlock) {
            questionBlock.addEventListener("click", () => {
                const isOpen = card.classList.contains("active");

                // Close other cards inside the current tab parent container
                const parentTabContent = card.closest(".dc-faq-content-item");
                const siblings = parentTabContent.querySelectorAll(".dc-faq-card");

                siblings.forEach(sibling => {
                    sibling.classList.remove("active");
                    const sibAnswer = sibling.querySelector(".dc-faq-answer");
                    if (sibAnswer) {
                        sibAnswer.style.maxHeight = "0px";
                    }
                });

                // Toggle active card
                if (!isOpen) {
                    card.classList.add("active");
                    answerBlock.style.maxHeight = answerBlock.scrollHeight + "px";
                }
            });
        }
    });

    /* ==========================================================================
       10. AUTOMATIC COLLAPSIBLE READ MORE FOR ALL SECTION HEADINGS' PARAGRAPHS
       ========================================================================== */
    const headingParagraphs = document.querySelectorAll(
        ".dc-section-header p, .dc-testimonials-info p, .dc-newsletter-box p, .dc-brands-intro p, .dc-parts-overview p"
    );

    headingParagraphs.forEach(p => {
        // Skip elements that are inside a readmore wrapper or already have toggle controls
        if (p.closest('.dc-section-readmore-wrapper') || p.closest('.dc-no-readmore')) {
            return;
        }

        const text = p.textContent.trim();
        // Cutoff limit: 140 characters
        if (text.length > 140) {
            const shortText = text.substring(0, 140) + "...";
            p.setAttribute("data-full-text", text);
            p.setAttribute("data-short-text", shortText);

            // Set initial short text
            p.innerHTML = shortText;

// Create read more button
const btn = document.createElement("button");
btn.className = "dc-inline-readmore-btn";
btn.textContent = "Read More";
btn.type = "button";
// Insert button after the paragraph element
p.parentNode.insertBefore(btn, p.nextSibling);

btn.addEventListener("click", (e) => {
    e.preventDefault();
    const isCollapsed = btn.textContent === "Read More";
    if (isCollapsed) {
        p.innerHTML = p.getAttribute("data-full-text");
        btn.textContent = "Read Less";
    } else {
        p.innerHTML = p.getAttribute("data-short-text");
        btn.textContent = "Read More";
    }
});
        }
    });

    // Custom read-more handling for multi-paragraph wrapper
    const readmoreWrappers = document.querySelectorAll('.dc-section-readmore-wrapper');
    readmoreWrappers.forEach(wrapper => {
        // Check for an existing button placed after the wrapper
        let btn = null;
        const next = wrapper.nextElementSibling;
        if (next && next.matches('button.dc-inline-readmore-btn[data-target]')) {
            btn = next;
        } else {
            btn = document.createElement('button');
            btn.className = 'dc-inline-readmore-btn';
            btn.type = 'button';
            btn.textContent = 'Read More';
            // Insert button after the wrapper element
            wrapper.parentNode.insertBefore(btn, wrapper.nextSibling);
        }
        // Ensure button toggles the correct wrapper
        btn.addEventListener('click', () => {
            const isCollapsed = btn.textContent === 'Read More';
            if (isCollapsed) {
                wrapper.style.display = 'block';
                btn.textContent = 'Read Less';
            } else {
                wrapper.style.display = 'none';
                btn.textContent = 'Read More';
            }
        });
        // initially hide wrapper if not already visible
        if (wrapper.style.display !== 'block') {
            wrapper.style.display = 'none';
        }
    });

    /* ==========================================================================
       11. DYNAMIC AJAX CART UPDATER
       ========================================================================== */
    const updateCartCount = () => {
        fetch("/cart.json")
            .then(res => res.json())
            .then(cart => {
                const cartCountBadges = document.querySelectorAll(".cart-count");
                cartCountBadges.forEach(badge => {
                    badge.textContent = cart.item_count;
                });
            })
            .catch(err => console.error("Error fetching cart data:", err));
    };

    // Listen to form submissions for adding items to the cart
    document.addEventListener("submit", (e) => {
        const form = e.target;
        if (form.action && form.action.includes("/cart/add")) {
            e.preventDefault();
            const formData = new FormData(form);

            fetch("/cart/add.js", {
                method: "POST",
                body: formData
            })
            .then(res => res.json())
            .then(item => {
                // Instantly update the cart icon counts dynamically
                updateCartCount();

                // Visual feedback on the button
                const btn = form.querySelector(".btn-cart");
                if (btn) {
                    const originalText = btn.textContent;
                    btn.textContent = "Added!";
                    btn.style.backgroundColor = "var(--primary-light)";
                    setTimeout(() => {
                        btn.textContent = originalText;
                        btn.style.backgroundColor = "";
                    }, 2000);
                }
            })
            .catch(err => {
                console.error("AJAX Cart error, falling back to standard submit:", err);
                form.submit();
            });
        }
    });
});